import React, { FC } from 'react';
import cn from 'classnames';

import { RateFromT } from '..';
import { isMobileOrTablet } from 'client/hooks/responsive';

import css from './CircleRate.module.scss';

const styles = {
  mako: {
    // backgroundColor: '#1cb3bd',
    borderColor: '#1cb3bd',
  },

  booking: {
    // backgroundColor: '#03377C',
    borderColor: '#03377C',
  },
};

type Props = {
  rate: number;
  from: RateFromT;
};

export const CircleRate: FC<Props> = ({ rate, from }) => {
  const isMobile = isMobileOrTablet();

  const [isAnimated, setIsAnimated] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimated(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const arr = Array.from({ length: 5 }, (item, index) => ({
    id: String(index),
  }));

  const filledCirclesAmount = (): number => {
    if (rate >= 8 && rate < 9) return 4;

    return Math.ceil(rate / 2);
  };

  return (
    <>
      <div className={cn(css.circles, isMobile && css.mobile)}>
        {arr.map((item, index) => {
          const isFilledStyle = filledCirclesAmount() > index;

          return (
            <div
              className={cn(css.circle, isAnimated && css.animated)}
              style={{
                color: isFilledStyle ? styles[from].borderColor : 'transparent',
                borderColor: styles[from].borderColor,
              }}
              key={`${index}&${item.id}`}
            />
          );
        })}
      </div>
    </>
  );
};
